import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

export const useNotificationUIStore = defineStore('notification-ui', () => {
  // UI State only - no server data
  const notificationVisibility = ref<'all' | 'unread'>('all')
  const markAllRead = ref(false)
  const loadMoreNotifications = ref(false)
  const showNotificationList = ref(false)

  // Actions
  const setNotificationVisibility = (visibility: 'all' | 'unread') => {
    notificationVisibility.value = visibility
  }

  const setMarkAllRead = (value: boolean) => {
    markAllRead.value = value
  }

  const setLoadMoreNotifications = (value: boolean) => {
    loadMoreNotifications.value = value
  }

  const setShowNotificationList = (value: boolean) => {
    showNotificationList.value = value
  }

  const reset = () => {
    notificationVisibility.value = 'all'
    markAllRead.value = false
    loadMoreNotifications.value = false
    showNotificationList.value = false
  }

  return {
    // State
    notificationVisibility: computed(() => notificationVisibility.value),
    markAllRead: computed(() => markAllRead.value),
    loadMoreNotifications: computed(() => loadMoreNotifications.value),
    showNotificationList: computed(() => showNotificationList.value),

    // Actions
    setNotificationVisibility,
    setMarkAllRead,
    setLoadMoreNotifications,
    setShowNotificationList,
    reset,
  }
})
